<template>
  <div class="home data-panel-home wechat-status-home">
    <Header title="设备状态查询"></Header>
    <el-alert
      title="本功能需要先将设备所属账号绑定至博纳云微信公众号"
      type="error"
    >
    </el-alert>
    <div class="bindEmail bind-email-wrap">
      <el-input
        class="wechat-bind-email"
        v-model="mac_address"
        placeholder="输入已绑定账号下的设备MAC"
      ></el-input>
      <div
        class="button wechat-bind-email"
        @click="clickSearch"
      >查询</div>
    </div>

    <div class="device-status-wrap" v-if="deviceStatus && deviceStatus.mac_address">
      <div class="item-wrap item-title">该设备状态</div>

      <div class="item-wrap">Mac地址： {{deviceStatus.mac_address}}</div>
      <div class="item-wrap">在线状态： <div v-if="!deviceStatus.status">-</div>
        <el-tag
          v-if="deviceStatus.status === 'online'"
          type="success"
        >online</el-tag>
        <el-tag
          v-if="deviceStatus.status === 'offline'"
          type="danger"
        >offline</el-tag>
      </div>
      <div class="item-wrap">DNS解析： {{deviceStatus.schedule ? '是' : '否'}}</div>
      <div class="item-wrap">外置硬盘： {{deviceStatus.storage_size}}</div>
      <div class="item-wrap">Node版本： {{deviceStatus.info}}</div>
      <div class="item-wrap">归属账号： {{deviceStatus.email}}</div>
      <div
        v-if="newTaskDetails"
        v-for="item in newTaskDetails"
        class="task-details"
      >
        <div class="item-wrap">
          运行任务：{{item.task}}
        </div>
        <div class="item-wrap">
          运行状态：
          <div v-if="item.status ==='Pending'">任务等待启动</div>
          <div v-if="item.status ==='NotRunning'">任务运行失败</div>
          <div v-if="item.status ==='Running'">任务正常运行</div>
        </div>
        <div>
          <div>
            <div  v-if="!deviceStatus.schedule">
              <div class="item-wrap bonus-tips">故障信息：不支持调度 </div>
              <div class="item-wrap bonus-tips">处理方式： 请检查设备DNS，并调整为223.5.5.5后重启</div>
            </div>
            <div v-else="deviceStatus.schedule">
              <div v-if="deviceStatus.last_manual_schedule_status ==='process'">
                <div class="item-wrap bonus-tips">故障信息：调度处理中，请等待</div>
                <div class="item-wrap bonus-tips">处理方式： 若2小时内未完成，请尝试重启后等待，若长期未生效，使用最新镜像重刷</div>
              </div>
              <div v-if="deviceStatus.last_manual_schedule_status ==='vol_ins'">
                <div class="item-wrap bonus-tips">故障信息：调度失败</div>
                <div class="item-wrap bonus-tips">处理方式： 硬盘空间不足，请格盘或更换硬盘</div>
              </div>
              <div v-if="deviceStatus.last_manual_schedule_status ==='applied'">
                <div v-if="item.status ==='Pending'">调度状态：等待任务启动</div>
                <div v-if="item.status ==='NotRunning'">
                  <div class="item-wrap bonus-tips">故障信息：任务运行失败</div>
                  <div class="item-wrap bonus-tips">处理方式：请前往论坛计算任务故障反馈贴留言</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "@/WechatComponents/Header.vue";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
import { getCookie } from "@/utils/utils";
import { Message } from "element-ui";

export default {
  name: "home",
  components: {
    Header
  },
  data() {
    return {
      mac_address: "",
      openId: "",
      code: "",
      deviceStatus: {},
      newTaskDetails: []
    };
  },
  computed: mapState({
    openid: state => state.wechat.openid,
    emails: state => state.wechat.emails
  }),
  created() {
    try {
      let that = this;
      let openid = getCookie("openid") || this.$route.query.openid;

      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2fdeviceStatus";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;
      // alert("search", window.location.search);
      // alert("href", window.location.href);

      if (openid || code) {
        this.openId = openid;
        this.code = code;

        // this.getDeviceStatus({ openid, code });
      } else {
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions(["getDeviceStatus", "bindWechatEmail"]),
    clickSearch() {
      let that = this;
      let { mac_address, openId, code } = this;

      that.getDeviceStatus({ openid: openId, code, mac_address }).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.deviceStatus = res.data;
          let task_details = res.data.task_details;
          let newTaskDetails = [];
          if (task_details) {
            for (var i in task_details) {
              newTaskDetails.push({
                task: i,
                status: task_details[i].status,
                solution: task_details[i].solution
              });
            }
          }
          this.newTaskDetails = newTaskDetails;
        } else {
          Message({
            type: "error",
            message: res.message || "网络开小差，请重试"
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus">
.data-panel-home.home {
  height: auto !important;
}

.wechat-home {
  background: #fff;
  text-align: center;
  padding: 20px;
}

.bind-email-wrap {
  padding: 30px 20px;
  background: #fff;
  text-align: center;
}

.wechat-bind-email {
  margin: 20px 0;
}

.wechat-bind-email {
  margin-top: 20px;
}

.wechat-page {
  background: #fff;
  height: auto !important;
  min-height: 100%;

  .home {
    height: 100% !important;
  }
}

.wechat-page .tips {
  margin: 60px 0;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-wrap {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.device-status-wrap{
  margin: 15px 20px;
  background: #fff;
  padding: 20px;
  border: 1px solid #ddd;
}

body.is-wechat {
  background: #fff!important;
  padding-bottom: 20px;
}

.task-details{
  margin: 28px 0;
}

.item-title{
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 30px;
}

.wechat-status-home{
  padding-bottom: 20px;
}
</style>

